import { Component, OnInit } from '@angular/core';
import { mywalletstore } from '../../../_services/mywallet/store/mywallet.store.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { SendMoneyService } from '../../../_services/sendmoneyservice/sendmoneyservice';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Router } from '@angular/router';
import { DeletestoreComponent } from '../deletestore/deletestore.component';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { AlertPopupComponent } from '../../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { enumStatusCodeList } from '../../../sharedcomponents/_common/constants/app.constants';
@Component({
  selector: 'app-store-locator-storedetail',
  templateUrl: './store-locator-storedetail.component.html',
  providers: [AlertService]
})
export class StoreLocatorStoredetailComponent implements OnInit {
  storeDetail: any = {};
  storeImgData;
  constructor(
    private mywalletstoreSer: mywalletstore,
    public utilServ: utilityService,
    private smService: SendMoneyService,
    private alertService: AlertService,
    private translate: TranslateService,
    private modal: Modal,
    private router: Router
  ) {}

  ngOnInit() {
    this.mywalletstoreSer.getStoreData().subscribe(data => {
      this.storeDetail = data;
    });
    if (this.storeDetail == undefined) {
      this.router.navigate(['/dashboard']);
    }
    // this.smService.getstoreimage(this.utilServ.getObjectText(this.storeDetail.storeId)).subscribe(
    //   storeData => {
    //     if (
    //       storeData.Envelope.Body.StoreStoreImageResponse.StatusCode == 1000 ||
    //       storeData.Envelope.Body.StoreStoreImageResponse.StatusCode == 10021 // Image not founde
    //     ) {
    //       this.storeImgData = 'data:image/gif;base64,' + storeData.Envelope.Body.StoreStoreImageResponse.StoreImageData;
    //     }
    //   },
    //   error => {
    //     //console.log('Unable to fetch Store Image');
    //   }
    // );
  }

  openGoogleDirectionmap(c) {
    window.open(
      'https://www.google.com/maps/dir/?api=1&origin=My+Location&destination=' +
        this.utilServ.getObjectText(c.storeaddress.Address1) +
        ' ' +
        this.utilServ.getObjectText(c.storeaddress.City) +
        ' ' +
        this.utilServ.getObjectText(c.storeaddress.StateCode) +
        ' ' +
        this.utilServ.getObjectText(c.storeaddress.CountryCode)
    );
  }

  callStore(phoneNumber) {
    if (phoneNumber != undefined) {
      this.alertService.openErrorAlert(
        this.translate.instant('Common_lblInfo'),
        this.translate.instant('Message_lblCustomerCareContactPrefix') + ' ' + this.utilServ.getObjectText(phoneNumber) + ' ' + this.translate.instant('Common_lblStoreContact')
      );
    } else {
      this.alertService.openErrorAlert(this.translate.instant('Common_lblInfo'), this.translate.instant('Message_customerCareError'));
    }
  }
  deletestore(store) {
    const modalData: any = {};
    const _self = this;
    modalData.Title = this.translate.instant('Common_lblInfo').toString();
    modalData.Message = this.translate.instant('DeleteStorePopup_desc').toString();
    modalData.Action = this.translate.instant('Common_lblContinue').toString();
    modalData.store = store;
    //  this.modal.overlay.defaultViewContainer = this.vcRef;
    return this.modal.open(DeletestoreComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.next == 'yes') {
          const modalData: any = {};
          modalData.Title = _self.translate.instant('Common_lblInfo').toString();
          modalData.Action = _self.translate.instant('Common_lblOk').toString();

          _self.mywalletstoreSer.deletestoreservice(_self.utilServ.getObjectText(store.storeId)).subscribe(
            data => {
              if (data.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.SUCCESS) {
                modalData.Message = _self.translate.instant('MyWallet_lblDeleteMessage').toString();
              } else {
                modalData.Message = _self.translate.instant('Message_errorMessage').toString();
              }
              return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
                obj.onDestroy.subscribe(data => {
                  // _self.ngOnInit();
                  _self.router.navigate(['/mywallet']);
                });
              });
            },
            error => {
              //console.log('Something went wrong,Unable to delte cart Item');
              this.closePopup();
            }
          );
        } else {
          // _self.closePopup();
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/mywallet/store/store-locator-storedetail/store-locator-storedetail.component.ts